import React from 'react';
import './index.scss';
import { Iconfont } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { classSet } from '@umu/umu-dom';
import { isInApp } from '@umu/umu-ua';
interface IProps {
    content?: string | JSX.Element;
    onBack?: () => void;
    onSearch?: () => void;
}
const HeardIndex = (props: IProps) => {
    const { content = lang('选择部门'), onBack, onSearch } = props;
    return (
        <div className={classSet({
            'comment-search-index-heard':true,
            'comment-search-heard-in-app': isInApp(),
        })}>
            <Iconfont type="SmallBack" className="icon-info" onClick={onBack} />
            <div>{content}</div>
            <Iconfont type="Search" className="icon-info" onClick={onSearch} />
        </div>
    );
};

export { HeardIndex };
